import React, { Component } from "react";
import { Link } from "react-router-dom";
import { trans } from "../../helpers/index";
import config from "../../baseConfig/index";
import AuthRightSidebar from "../Fragments/AuthRightSidebar";
import StepOne from "./Forms/StepOne";
import MobStepTwo from "./Forms/MobStepTwo";
import MobStepThree from "./Forms/MobStepThree";
import EmailStepTwo from "./Forms/EmailStepTwo";
import EmailStepThree from "./Forms/EmailStepThree";
import Tab from "../Fragments/Tab";
import B2bStepOne from "./Forms/b2b/B2bStepOne";

class ForgotPasswordView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      userName: "",
      token: "",
      type: "mob",
      b2bUserName: "",
    };
    this.updateParentState = this.updateParentState.bind(this);
  }

  updateParentState(newState) {
    this.setState(newState);
  }

  drawForms() {
    let result = "";

    switch (true) {
      case this.state.step === 2 && this.state.type === "email":
        result = (
          <EmailStepTwo
            csrf_token={this.props.csrf_token}
            trans={this.props.trans}
            forgotConfig={this.state}
            updateParentState={this.updateParentState}
            setLoginAction={this.props.setLoginAction}
          />
        );
        break;

      case this.state.step === 3 && this.state.type === "email":
        result = (
          <EmailStepThree
            csrf_token={this.props.csrf_token}
            trans={this.props.trans}
            forgotConfig={this.state}
            updateParentState={this.updateParentState}
            setLoginAction={this.props.setLoginAction}
          />
        );
        break;

      case this.state.step === 3 && this.state.type === "mob":
        result = (
          <MobStepThree
            csrf_token={this.props.csrf_token}
            trans={this.props.trans}
            forgotConfig={this.state}
            updateParentState={this.updateParentState}
            setLoginAction={this.props.setLoginAction}
          />
        );
        break;

      case this.state.step === 2 && this.state.type === "mob":
        result = (
          <MobStepTwo
            csrf_token={this.props.csrf_token}
            trans={this.props.trans}
            forgotConfig={this.state}
            updateParentState={this.updateParentState}
          />
        );
        break;

      default:
        result = (
          <StepOne
            csrf_token={this.props.csrf_token}
            trans={this.props.trans}
            forgotConfig={this.state}
            updateParentState={this.updateParentState}
            setTokenAction={this.props.setTokenAction}
          />
        );
    }

    return result;
  }

  render() {
    return (
      <div className="main-wrapper">
        <aside className="main-wrapper__left scroller-block">
          <div className="main-wrapper__left-inner">
            <Link
              className="main-wrapper__logo sprite db"
              to={config.urlPrefix}
            >
              {trans("logo.title")}
            </Link>

            <Tab
              items={[
                {
                  title: trans(this.props.trans, "auth.login.tab.title1"),
                  content: this.drawForms(),
                  changeUrlTo: "forgot-password-b2c",
                  clickCallback: () => this.props.setCurrentTabAction(0),
                },
                {
                  title: trans(this.props.trans, "auth.login.tab.title2"),
                  content: (
                    <B2bStepOne
                      csrf_token={this.props.csrf_token}
                      trans={this.props.trans}
                      history={this.props.history}
                      updateParentState={this.updateParentState}
                      setTokenAction={this.props.setTokenAction}
                    />
                  ),
                  changeUrlTo: "forgot-password-b2b",
                  clickCallback: () => this.props.setCurrentTabAction(1),
                },
              ]}
              index={this.props.isB2b ? 1 : 0}
              history={this.props.history}
            />
          </div>
        </aside>

        <AuthRightSidebar trans={this.props.trans} />
      </div>
    );
  }
}

export default ForgotPasswordView;
